import MESSAGES from '../../../../../../../../../appMessages';
import { createExceptionUtils } from '../utils';
import { EXCEPTION_NUMBER_VALIDATION } from '../../../../common/constants';

const VALIDATED_FIELDS = ['code', 'adeNumber'];

const ADEException = (config = {}) => {
  const {
    minExceptionNumberLength,
    maxExceptionNumberLength,
    exceptionNumberLabel
  } = config;

  const validateExceptionField = (name, value) => {
    if (name === 'adeNumber') {
      if (value == null || value === '') {
        return MESSAGES.PROCESS_DELIVERY.ADE_REQUIRED_DYNAMIC
          .replace('{label}', exceptionNumberLabel);
      }
      const stringValue = String(value).trim();
      if (stringValue === '') {
        return MESSAGES.PROCESS_DELIVERY.ADE_REQUIRED_DYNAMIC
          .replace('{label}', exceptionNumberLabel);
      }

      // Validate based on min/max range (inclusive). When min === max, show exact-length message (same as before)
      const minLength = minExceptionNumberLength ?? EXCEPTION_NUMBER_VALIDATION.DEFAULT_MIN_LENGTH;
      const maxLength = maxExceptionNumberLength ?? EXCEPTION_NUMBER_VALIDATION.DEFAULT_MAX_LENGTH;
      if (stringValue.length < minLength || stringValue.length > maxLength) {
        if (minLength === maxLength) {
          return MESSAGES.PROCESS_DELIVERY.INVALID_ADE_LENGTH_DYNAMIC
            .replace('{label}', exceptionNumberLabel)
            .replace('{length}', minLength);
        }
        return MESSAGES.PROCESS_DELIVERY.INVALID_ADE_LENGTH_RANGE_DYNAMIC
          .replace('{label}', exceptionNumberLabel)
          .replace('{min}', minLength)
          .replace('{max}', maxLength);
      }
      return null;
    }

    if (name === 'code' && (value == null || value === '')) {
      return MESSAGES.PROCESS_DELIVERY.OSND_DETAIL_REQUIRED;
    }

    return null;
  };

  const getExceptionDetailsObject = (exceptionDetail = {}) => ({
    code: exceptionDetail.code ?? null,
    adeNumber: exceptionDetail.adeNumber ?? null,
    errorInfo: {
      code: null,
      adeNumber: null
    }
  });

  return createExceptionUtils({
    validatedFields: VALIDATED_FIELDS,
    validateExceptionField,
    getExceptionDetailsObject
  });
};

export default ADEException;
